import { render, staticRenderFns } from "./PosEditProductData.vue?vue&type=template&id=fdd26802&scoped=true&"
import script from "./PosEditProductData.vue?vue&type=script&lang=js&"
export * from "./PosEditProductData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd26802",
  null
  
)

export default component.exports